module.exports = __webpack_public_path__ + "img/icon_t18.94d9c061.png";